<template>
  <div class="md-layout" v-if="challenge">
    <landing-page :landingPage="landingPage" v-if="landingPage" />
    <small-challenge-info-card :challenge="challenge" />
    <cart
      class="md-layout-item md-size-100"
      v-if="
          challenge &&
          challenge.merchandise &&
          challenge.merchandise.length
      "
      :hasJoined="hasJoined"
      :challenge="challenge"
      :initialCode="urlCode"
      @submit-join-form="submit($event)"
    />
    <md-card
        class="md-layout-item md-size-100"
        v-else-if="
        !hasJoined &&
          challenge &&
          challenge.joinForm &&
          challenge.joinForm.fields &&
          challenge.joinForm.fields.length
      "
    >
      <md-card-header class="md-card-header-text md-card-header-green">
        <div class="card-text">
          <h4 class="title">Jetzt mitmachen!</h4>
        </div>
      </md-card-header>
      <md-card-content>
        <dynamic-form
          :formFields="challenge.joinForm.fields"
          @submit="submit($event)"
          submitButtonText="Jetzt anmelden!"
          style="max-width: 600px; margin: 0 auto;"
        />
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import {mapState} from "vuex";
import appendUrlParam from '@/utils/appendUrlParam';
import Cart from "@/components/Cart/Cart";
import LandingPage from 'sports4me-web_components/atomic-design/molecules/landing-page.vue';
import SmallChallengeInfoCard from 'sports4me-web_components/atomic-design/molecules/small-challenge-info-card.vue';

export default {
  components: { Cart, LandingPage, SmallChallengeInfoCard },
  data() {
    return {
      landingPage: null,
      challengeId: this.$route.params.id,
      challenge: undefined,
      urlCode: this.$route.query['code'] || this.$route.query['join-code'] || this.$route.query['voucher'] || undefined,
    }
  },
  computed: {
    ...mapState({
      userId: state => state.user && state.user._id,
      isAdmin: state => state.isAdmin || false
    }),
    hasJoined() {
      return (
          this.challenge &&
          !!this.challenge.joined.find(u => u.userId === this.userId)
      );
    },
  },
  beforeMount() {
  },
  mounted() {
    console.log(this.challenge)
    console.log(this.hasJoined)

    this.$root.$on('codeInfoUpdated', (v) => {
        this.landingPage = v;
      })
    this.$store
        .dispatch("queryAPI", {url: "/rest/challenge/" + this.challengeId + "?v=1"})
        .then(res => {
          this.challenge = res;
        })
        .catch(err => {
          this.$notify({
            timeout: 5000,
            message: err.message,
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger"
          });
        });
  },
  methods: {
    submit(formData) {
      let data = {
        id: this.challengeId,
        form: formData
      };
      this.$store
          .dispatch("submitChallengeForm", data)
          .then(() => {
            goToRoute(`/challenges/${this.challengeId}`);
            // window.history.replaceState(null, '', appendUrlParam(window.location.href, { 'joined': 'true' }));
            // window.location.reload();
          })
          .catch(err => {
            let message = err.message;
            if (err.code === 'INVALID_JOIN_CODE') {
              message = 'Der angegebene Anmelde-Code ist leider ungültig';
            }
            this.$notify({
              timeout: 5000,
              message,
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger"
            });
          });
    },
  }
}
</script>

